module.exports = __webpack_public_path__ + "img/sugar-and-cinnamon.87922274.png";